// removed by extract-text-webpack-plugin
module.exports = {"article":"_8E1x","image":"_2HZC","horizontal":"_1tDk","tags":"_1rGX","content":"_2pDc","title":"VM9L","meta":"_2FxO","metaLink":"oF8t","descrip":"_3xUA"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Blog/BlogPreview/BlogPreview.scss
// module id = pBCr
// module chunks = 0